"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileUpload = exports.checkApiStatus = void 0;
var _utils = require("@thinkvn/utils");
var _fileType = require("./file-type");
const BASE_URL = "https://api.shortpixel.com/v2";
const COMPRESS_TYPE = {
  lossy: 1,
  glossy: 2,
  lossless: 0
};
const toFormData = data => {
  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};
const toBlob = url => {
  return fetch(url).then(res => res.blob());
};
const fileUpload = async (file, params) => {
  try {
    const key = (0, _utils.shuffle)(params.keys)[0];
    const filename = (0, _utils.toKebabCase)((0, _fileType.getNameFromFilename)(file.name));
    const response = await fetch(BASE_URL + "/post-reducer.php", {
      method: "POST",
      body: toFormData({
        key,
        lossy: COMPRESS_TYPE.glossy,
        file_paths: JSON.stringify({
          [filename]: file.name
        }),
        [filename]: file,
        wait: 30
      })
    }).then(res => res.json());
    if (response.Status) {
      if (response.Status.Code === -403) {
        const keys = (0, _utils.without)(params.keys, key);
        if (keys.length === 0) {
          return "NOT_FOUND_KEY";
        }
        return fileUpload(file, {
          keys
        });
      }
      return null;
    }
    if (!response.length) {
      return null;
    }
    const lossyUrl = response[0].LossyURL.replace("http://", "https://");
    return await toBlob(lossyUrl);
  } catch (e) {
    console.log("e", e);
    return null;
  }
};
exports.fileUpload = fileUpload;
const checkApiStatus = async key => {
  try {
    const {
      APICallsMade,
      APICallsQuota
    } = await fetch("https://api-qc.thinkpro.vn/cms/proxy/short-pixel/status", {
      method: "POST",
      body: toFormData({
        key
      })
    }).then(res => res.json());
    return Number(APICallsMade) < Number(APICallsQuota);
  } catch (e) {
    console.log("e", e);
    return false;
  }
};
exports.checkApiStatus = checkApiStatus;